var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.2648C19 13.111 15.4774 17.8247 13.43 20.324C12.6809 21.2384 11.3191 21.2384 10.57 20.324C8.52261 17.8247 5 13.111 5 10.2648C5 6.25262 8.13401 3.00012 12 3.00012C15.866 3.00012 19 6.25262 19 10.2648Z",
    stroke: "#675D75",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 11.5804 9 14 12 14C15 14 16 11.5804 16 9.99998C16 7.77217 14.7614 5.99998 12 5.99998C9.23858 5.99998 8 7.77219 8 10Z",
    stroke: "#675D75",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.c07f9db77b680effa16032c5c06599e1.svg";
export { ForwardRef as ReactComponent };